import React from "react";

const CloseIcon = () => (
  <svg
    width="12px"
    height="16px"
    viewBox="0 0 12 12"
    version="1.1"
    style={{ cursor: "pointer" }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Desktop-|-Client-Search-results-EMPTY"
      transform="translate(-537.000000, -364.000000)"
      fill="#000000"
    >
      <g id="ic-close-36px" transform="translate(537.000000, 362.000000)">
        <polygon
          id="Path"
          points="11.7272727 1.42909091 10.5709091 0.272727273 6 4.84363636 1.42909091 0.272727273 0.272727273 1.42909091 4.84363636 6 0.272727273 10.5709091 1.42909091 11.7272727 6 7.15636364 10.5709091 11.7272727 11.7272727 10.5709091 7.15636364 6"
        />
      </g>
    </g>
  </svg>
);

export default CloseIcon;
